<template>
	<div>
		<b-spinner variant="primary" class="spinStyle" v-show="showSpin" label="Text Centered"></b-spinner>
		<b-row style="margin-top:10px;">
			<b-col lg="12">
				<div style="display:flex;">
					<div class="search-productInfo">
						<b-input-group style="width:200px;margin-right:10px;">
							<b-form-input size="sm" v-model="productSearchValue" placeholder="输入编码或品名"></b-form-input>
							<b-input-group-append>
								<b-button size="sm" v-on:click="searchProductByName()">查询</b-button>
							</b-input-group-append>
						</b-input-group>
					</div>
					<!-- <div class="search-color">
						<label>产品颜色:</label>
						<b-form-select v-model="productColor" size="sm" @change="onProductColorChange"
							style="width:200px;">
							<option :value="0">全部</option>
							<option :value="series.productColor" v-for="series in seriesList" :key="series.seriesUuid">
								{{series.productColor}}
							</option>
						</b-form-select>
					</div> -->
				</div>
				<div v-if="selectedMainCateUuid || selectedSubCateUuid"
					style="display: flex;align-items: center;margin-top: 10px;">
					<span style="font-size:14px;color:gray;">分类筛选:</span>
					<Tag v-if="selectedMainCateUuid" style="margin-left:10px" size="medium" closable
						@on-close="onCloseMainCateFilter">{{selectedMainCateName}}</Tag>
					<Tag v-if="selectedSubCateUuid" style="margin-left:10px" size="medium" closable
						@on-close="onCloseSubCateFilter">{{selectedSubCateName}}</Tag>
				</div>

				<div style="display:flex;">
					<!-- 边栏 -->
					<div style="margin-top:10px;margin-right:10px; width:190px;">
						<b-list-group>
							<b-list-group-item class="product-list" v-for="(mainCate, index) in  mainCateList"
								:key="index" v-on:click="onSelectMainCate(mainCate)" style="padding:6px;">
								<div :id="mainCate.mainCategoryUuid">
									<img :src="mainCate.mainCategoryFile" width="30" height="30">
									<span>{{mainCate.mainCategoryName}}</span>
								</div>
								<b-popover :target="mainCate.mainCategoryUuid" triggers="hover" placement="rightbottom">
									<template #title>{{mainCate.mainCategoryName}}</template>
									<template #default>
										<div>
											<div class="sidebar-subcate"
												v-for="sub in subCateList.filter(e => {return e.subCategoryMainUuid === mainCate.mainCategoryUuid;})"
												:key="sub.subCategoryUuid" v-on:click="onSelectSubCate(sub)">
												<img :src="sub.subCategoryFile" width="30" height="30">
												<span>{{sub.subCategoryName}}</span>
											</div>
										</div>
									</template>
								</b-popover>
							</b-list-group-item>
						</b-list-group>
						<div class="product-pay">
							<div>账号：{{memberInfo.memberName}}</div>
							<div>可用余额：{{memberInfo|formatAvailableBalance}}元</div>
							<div style="text-align:center;margin-top:5px;">
								<b-button size="sm" variant="info" @click="onPay()">
									会员充值
								</b-button>
							</div>
						</div>
						
						<div class="product-pay">
							<div>客户经理: {{memberInfo.memberRelateCustomerManagerName}}</div>
							<div>客户经理联系电话: {{memberInfo.memberRelateCustomerManagerPhone}}</div>
						</div>
					</div>
					<!-- 主表 -->
					<div style="width:100%;">
						<div class="dataTable">
							<b-table id="product-table" :fields="productFields" :items="prodcutItems" small bordered
								hover show-empty empty-text="没有找到匹配的记录" :busy="isTableBusy">
								<template v-slot:cell(productImg)="row">
									<img :src="row.item.showImageUrl" width="30" height="30"
										@click="showProductDetail(row.item)">
								</template>
								<!-- 订购数量 -->
								<template v-slot:cell(orderQuantity)="row">
									<b-form-input size="sm" type="number" style="width:80px;"
										:step="row.item.productIncreaseStepAmount"
										:min='row.item.productMinOrderAmount'
										@blur="updateOrderAmount($event,row.item)"
										v-model="row.item.productPreSaleWarehouseAmount">
									</b-form-input>
								</template>
								<!-- 选择周次 -->
								<template v-slot:cell(selectWeek)="row">
									<b-form-select v-model="filterModel.selectedWeek" size="sm" @change="changeDays(row.item)"  @click.native="onWeekSelectChange(row.item)">
										<option :value="week.weekKnownText" v-for="week in filterModel.newWeekList" :key="week.weekUuid">
											{{week.weekKnownTextCh}}
										</option>
									</b-form-select>
								</template>
								<!-- 选择发货日期 -->
								<template v-slot:cell(deliveryDate)="row">
									<b-form-select v-model="row.item.selectDay" size="sm">
										<option :value="day" v-for="day in row.item.dayList" :key="day">
											{{day}}
										</option>
									</b-form-select>
								</template>
								<template v-slot:cell(orderButton)="row">
									<div>
										<a href="#" :style="{color: getColorbyProductId(row.item.productUuid)}" v-on:click="addToCart(row.item)">加入购物车</a>
									</div>
								</template>
								<div slot="table-busy" class="text-center text-info my-2">
									<b-spinner class="align-middle"></b-spinner>
									<strong>加载中...</strong>
								</div>
							</b-table>
						</div>
						<div class="pageControl">
							<b-pagination v-model="feSearch.limit.conditions.pageStart" style="margin-top:20px;"
								:total-rows="feSearch.limit.conditions.total"
								:per-page="feSearch.limit.conditions.pageLength" align="center" size="sm"
								ellipsis-text="..." first-text="首页" prev-text="上一页" next-text="下一页" last-text="尾页"
								limit="10" @change="onPageChange"></b-pagination>
						</div>
					</div>
				</div>
			</b-col>
		</b-row>
		<product-detail ref="productDetail" />

		<PayModal ref="payModal" />
	</div>
</template>

<script>
	import api from '@/api/api';
	import search from '@/libs/search';
	import signalr from '@/libs/signalr';
	import { ConnectionState, getStateName } from '@/libs/signalr';
	import {
		numberToFixed,
		arrayUnique,
		getTodayDateString,
		getNumberThousandString,getNumberFloorDecimal,numberSubtraction
	} from "@/libs/utils";

	import "@/style/global.css";
	import ProductDetail from './product-detail.vue';
	import PayModal from '../member/pay.vue';
	export default {
		name: 'ProductList',
		components: {
			ProductDetail,
			PayModal
		},
		data() {
			return {
				hadSelectedProductUuids:[],
				showSpin: false,
				isTableBusy: false,
				productFields: [{
						key: 'productImg',
						label: '缩图'
					},
					{
						key: 'productCode',
						label: '编码'
					},
					{
						key: 'productName',
						label: '品名',
						class: 'table-cloumn-max-width'
					},
					{
						key: 'brandName',
						label: '品牌'
					},
					{
						key: 'productSpec',
						label: '规格',
						class: 'table-cloumn-max-width'
					},
					{
						key: 'productPackageQuantity',
						label: '装箱量'
					},
					{
						key: 'unitName',
						label: '单位'
					},
					{
						key: 'productPreSalePrice',
						label: '单价'
					},
					{
						key: 'productIncreaseStepAmount',
						label: '最小单位指标',

					},
					{
						key: 'orderQuantity',
						label: '订购数量'

					},
					{
						key: 'selectWeek',
						label: '选择周次',
						class: 'table-cloumn-min-width'
					},
					{
						key: 'deliveryDate',
						label: '选择发货日期',
						class: 'table-cloumn-min-width'
					},
					{
						key: 'orderButton',
						label: '操作'

					}
				],
				zh: {
					weekdayHeaderFormat: 'narrow',
					labelPrevDecade: '过去十年',
					labelPrevYear: '上一年',
					labelPrevMonth: '上个月',
					labelCurrentMonth: '当前月份',
					labelNextMonth: '下个月',
					labelNextYear: '明年',
					labelNextDecade: '下一个十年',
					labelToday: '今天',
					labelSelected: '选定日期',
					labelNoDateSelected: '未选择日期',
					labelCalendar: '日历',
					labelNav: '日历导航',
					labelHelp: '使用光标键浏览日期'
				},
				prodcutItems: [],
				cartItems: [],
				feSearch: search.getSearchParams(),
				mainCateList: [],
				subCateList: [],
				selectedMainCateUuid: '',
				selectedMainCateName: '',
				selectedSubCateUuid: '',
				selectedSubCateName: '',
				productSearchValue: '',
				memberInfo: {
					memberName: '',
					memberFund: 0,
					memberRelateCustomerManagerName:'',
					memberRelateCustomerManagerPhone:''
				},
				selectedYear: [],
				yearList: [],
				selectedWeek: 0,
				monthList: [],
				weekList: [],
				curWeek: '',
				beginDate: '',
				endDate: '',
				favList: [],
				cartList: [],
				selectedProductInfo: '',
				existOnly: true,
				stationList: [],
				memberAddressStationList: [],
				priceOrder: 0,
				amountFontOrder: 0,
				seriesList: [],
				productColor: '',
				filterModel: {
					newWeekList:[],
					dayList: [],
					selectedWeek:1,
					selectDay:'',
					selectedYearPlans: [],
				},
				preSalePlanProduct:[], 
				unitList: []
			};
		},
		mounted() {
			let now = new Date();
			this.selectedYear = [now.getFullYear(), now.getFullYear() + 1, now.getFullYear() + 2, now.getFullYear() + 3, now.getFullYear() + 4];
			this.yearList = [now.getFullYear(), now.getFullYear() + 1, now.getFullYear() + 2, now.getFullYear() + 3, now.getFullYear() + 4];

			let query = this.$route.query;
			//从首页点击大类跳转进来
			if (query.mainCateUuid) {
				this.selectedMainCateUuid = query.mainCateUuid;
				this.selectedMainCateName = query.mainCateName;

				this.feSearch.filters.enable = true;
				this.feSearch.filters.conditions.push({
					name: 'productMainCategoryUuid',
					type: 'eq',
					value: this.selectedMainCateUuid
				});
			}

			if (query.productUuid) {
				this.existOnly = false;
				this.feSearch.filters.enable = true;
				this.feSearch.filters.conditions.push({
					name: 'productUuid',
					type: 'eq',
					value: query.productUuid
				});
			}

			if (this.checkMemberLogin()) {
				this.getMemberDetailInfo();
				this.getPreSalePlanProduct();
			}

			if (!this.checkMemberLogin()) {
				this.productFields = this.productFields.filter(item => item.key !== 'productPreSalePrice');
				this.productFields = this.productFields.filter(item => item.key !== 'orderQuantity');
				this.productFields = this.productFields.filter(item => item.key !== 'selectWeek');
				this.productFields = this.productFields.filter(item => item.key !== 'deliveryDate');
				this.productFields = this.productFields.filter(item => item.key !== 'orderButton');
			}

			this.getSalesPageData();
			this.onYearSelectChange(this.yearList);
            this.getUnitList();
			this.initSignalR();
			
		},
		methods: {
			getNumberThousandString,
			getNumberFloorDecimal,
			numberSubtraction,
			// 初始化 SignalR 连接
			initSignalR() {
				// 监听预售计划更新事件
				signalr.on('PreSalePlanUpdated', (preSalePlanModels) => {
					console.log('收到预售计划更新通知，数据：', preSalePlanModels);
					this.handlePreSalePlanUpdate(preSalePlanModels);
				});

				// 监听产品价格更新事件
				signalr.on('ProductPriceUpdated', (data) => {
					console.log('收到产品价格更新通知', data);
					if (data && data.preSalePlanProductUuid && data.preSalePlanPrice) {
						this.updatePrice(data.preSalePlanProductUuid, data.preSalePlanPrice);
						this.$bvToast.toast('产品价格已更新', {
							title: '价格更新',
							variant: 'info',
							autoHideDelay: 2000
						});
					}
				});

				// 连接状态监听 - 兼容 @aspnet/signalr 1.1.4 版本
				signalr.onclose(() => {
					console.log('SignalR 连接已关闭，准备重连');
				});

				// 注意：@aspnet/signalr 1.1.4 版本不支持 onreconnecting 和 onreconnected 事件
				// 重连逻辑通过 onclose 事件在 signalr.js 中处理

				// 检查连接状态并启动连接
				const connectionState = signalr.getConnectionState();
				console.log('当前 SignalR 连接状态:', connectionState);

				if (connectionState === ConnectionState.DISCONNECTED) {
					this.startSignalRConnection();
				} else if (connectionState === ConnectionState.CONNECTING) {
					console.log('SignalR 正在连接中，等待连接完成...');
				} else {
					console.log('SignalR 已连接，无需重复连接');
				}
			},

			// 启动 SignalR 连接
			startSignalRConnection() {
				signalr.start().then(() => {
					console.log('SignalR 连接成功');
				}).catch(err => {
					console.error('SignalR 连接失败:', err);
					// 重连逻辑已在 signalr.js 中处理，这里不需要重复处理
				});
			},

			// 处理预售计划更新
			handlePreSalePlanUpdate(preSalePlanModels) {
				// 校验发送来的preSalePlanModels中每个对象的属性preSalePlanProductUuid和prodcutItems的productUuid是否有一致的
				if (!preSalePlanModels || !Array.isArray(preSalePlanModels) || preSalePlanModels.length === 0) {
					console.log('收到的预售计划数据为空，跳过更新');
					return;
				}

				// 获取当前产品列表中的所有productUuid
				const currentProductUuids = this.prodcutItems.map(item => item.productUuid);

				// 校验是否有匹配的产品
				const hasMatchingProducts = preSalePlanModels.some(plan =>
					plan && plan.preSalePlanProductUuid && currentProductUuids.includes(plan.preSalePlanProductUuid)
				);

				if (hasMatchingProducts) {
					console.log('检测到相关产品更新，开始更新数据');

					// 刷新产品列表以获取最新价格
					this.getProductList();
					// 刷新预售计划产品列表
					this.getPreSalePlanProduct();

					// 如果当前有选中的产品，重新获取其预售计划
					if (this.hadSelectedProductUuids.length > 0) {
						this.hadSelectedProductUuids.forEach(productId => {
							this.getPreSaleProductList(productId);
						});
					}

					// 显示更新提示
					this.$bvToast.toast('价格和预售计划已更新', {
						title: '数据更新',
						variant: 'success',
						autoHideDelay: 3000
					});
				} else {
					console.log('当前页面产品与收到的预售计划更新不匹配，跳过更新');
				}
			},
			updateOrderAmount(event,item){
				let roundedValue;
				let value=Number(event.target.value);

				if(this.getUnitIsRounded(item.unitName)){
                    roundedValue = parseFloat(value.toFixed(2));
				}
                else{
	              // 四舍五入为整数
				 roundedValue = Math.round(value);
				}
				// 更新模型值
				item.productPreSaleWarehouseAmount = roundedValue;

			},
            //实时更新产品价格
            updatePrice(productId, price){
            	if (!productId || price === undefined || price === null) {
            		console.warn('价格更新参数无效:', { productId, price });
            		return;
            	}

            	const numericPrice = Number(price);
            	if (isNaN(numericPrice)) {
            		console.warn('价格格式无效:', price);
            		return;
            	}

            	let updatedCount = 0;
            	let updatedProductNames = [];

            	this.prodcutItems.forEach(pro =>{
            		if (productId == pro.productUuid) {
            			const oldPrice = pro.productPreSalePrice;
            			pro.productPreSalePrice = numericPrice;
            			updatedCount++;
            			updatedProductNames.push(pro.productName);
            			console.log(`产品 ${pro.productName} 价格更新: ${oldPrice} -> ${numericPrice}`);
            		}
            	});

            	if (updatedCount > 0) {
            		console.log(`成功更新 ${updatedCount} 个产品的价格`);
            		// 强制 Vue 重新渲染视图
            		this.$forceUpdate();
            	} else {
            		console.warn('未找到匹配的产品进行价格更新:', productId);
            	}
            },
			numberToFixed,
			arrayUnique,
			getTodayDateString,
			onPay() {
				if (!this.checkMemberLogin()) {
					this.$bvModal.msgBoxOk("请先登录", {
						title: '提示',
						buttonSize: 'sm'
					});
					return;
				}
				this.$refs.payModal.showModal();
			},
			showProductDetail(product) {
				this.$refs.productDetail.showModal(encodeURIComponent(JSON.stringify(product)));
			},
			onCloseMainCateFilter() {
				this.selectedMainCateUuid = '';
				this.selectedMainCateName = '';
				this.selectedSubCateUuid = '';
				this.selectedSubCateName = '';

				this.feSearch.filters.enable = true;
				search.globalRemoveFilterConditionKey(this.feSearch, 'productMainCategoryUuid');
				search.globalRemoveFilterConditionKey(this.feSearch, 'productSubCategoryUuid');
				search.globalResetSearch(this.feSearch);
				this.getProductList();
			},
			onCloseSubCateFilter() {
				this.selectedSubCateUuid = '';
				this.selectedSubCateName = '';
				this.feSearch.filters.enable = true;
				search.globalRemoveFilterConditionKey(this.feSearch, 'productSubCategoryUuid');
				search.globalResetSearch(this.feSearch);
				this.getProductList();
			},
			onSelectMainCate(mainCate) {
				this.selectedMainCateUuid = mainCate.mainCategoryUuid;
				this.selectedMainCateName = mainCate.mainCategoryName;
				this.selectedSubCateUuid = '';
				this.selectedSubCateName = '';

				this.feSearch.filters.enable = true;
				search.globalRemoveFilterConditionKey(this.feSearch, 'productMainCategoryUuid');
				search.globalRemoveFilterConditionKey(this.feSearch, 'productSubCategoryUuid');
				search.globalResetSearch(this.feSearch);
				if (this.selectedMainCateUuid) {
					this.feSearch.filters.conditions.push({
						name: 'productMainCategoryUuid',
						type: 'eq',
						value: this.selectedMainCateUuid
					});
				}
				this.getProductList();
			},
			onSelectSubCate(subCate) {
				this.selectedMainCateUuid = subCate.subCategoryMainUuid;
				this.selectedMainCateName = subCate.mainCategoryName;
				this.selectedSubCateUuid = subCate.subCategoryUuid;
				this.selectedSubCateName = subCate.subCategoryName;

				this.feSearch.filters.enable = true;
				search.globalRemoveFilterConditionKey(this.feSearch, 'productMainCategoryUuid');
				search.globalRemoveFilterConditionKey(this.feSearch, 'productSubCategoryUuid');
				search.globalResetSearch(this.feSearch);
				if (this.selectedMainCateUuid) {
					this.feSearch.filters.conditions.push({
						name: 'productMainCategoryUuid',
						type: 'eq',
						value: this.selectedMainCateUuid
					});
				}
				if (this.selectedSubCateUuid) {
					this.feSearch.filters.conditions.push({
						name: 'productSubCategoryUuid',
						type: 'eq',
						value: this.selectedSubCateUuid
					});
				}
				this.getProductList();
			},
			getNowString() {
				let now = new Date();
				let year = now.getFullYear();
				let month = now.getMonth() + 1;
				if (month < 10) {
					month = "0" + month;
				}
				let day = now.getDate();
				if (day < 10) {
					day = "0" + day;
				}
				return year + "-" + month + "-" + day;
			},
			onYearSelectChangeEvent(year) {
				this.onYearSelectChange(year);
			},
			getCurWeek() {
				let now = new Date();
				let beginDate = new Date(now.getFullYear(), 0, 1);
				return Math.ceil((parseInt((now - beginDate) / (24 * 60 * 60 * 1000)) + beginDate.getDay()) / 7);
			},
			getPreSalePlanProduct() {
				api.getPreSaleOrderProductPlanList({userUuid:''}).then(res=>{
					if(res.code==0){
						this.preSalePlanProduct=res.data;
					}
				
				})
			},
			getColorbyProductId(productId){
			  let hasIs=this.preSalePlanProduct.some(x=>x.productUuid==productId);
			  return hasIs?'#DDD':'#00B151';
			},
			onYearSelectChange(year) {
				this.selectedWeek = 0;
				let now = new Date();
				//种苗网周次以周一为开始，标准周次已周日开始，所以这里先减一天
				now = now.setDate(now.getDate() - 1);
				now = new Date(now);
				let beginDate = new Date(now.getFullYear(), 0, 1);
				this.curWeek = Math.ceil((parseInt((now - beginDate) / (24 * 60 * 60 * 1000)) + 1 + beginDate.getDay()) /
					7);
				let WeekTest = this.getCurWeek();
				this.showSpin = true;
				api.webGetWeekConfig({
					years: year
				}).then(res => {
					this.showSpin = false;
					if (res.code === 0) {
						let allWeeks = res.data;
						if (this.beginDate && !this.endDate) {
							this.weekList = allWeeks.filter(e => {
								return (
									e.weekEndDate > this.beginDate
								);
							});
						} else if (!this.beginDate && this.endDate) {
							this.weekList = allWeeks.filter(e => {
								return (
									e.weekEndDate > getTodayDateString() &&
									e.weekBeginDate < this.endDate
								);
							});
						} else if (this.beginDate && this.endDate) {
							this.weekList = allWeeks.filter(e => {
								return (
									e.weekEndDate > this.beginDate &&
									e.weekBeginDate < this.endDate
								);
							});
						} else {
							let nowString = this.getNowString();
							//let nowString = this.getDateString(this.deliveryStartDate);
							this.weekList = allWeeks.filter(e => {
								return (
									e.weekEndDate >= nowString
								);
							});
						}
						if (this.weekList.length > 0) {
							this.selectedWeek = this.weekList[0].weekKnownText;
							this.monthList = this.weekList.map(e => {
								return e.weekMonth;
							});
							this.monthList = this.arrayUnique(this.monthList);
							this.getProductList();
						} else {
							this.prodcutItems = [];
						}
					}
				});
			},
			getMemberDetailInfo() {
				api.getMemberDetailInfo({
					userUuid: this.getLoginCookieUuid()
				}).then(res => {
					if (res.code === 0) {
						this.memberInfo = res.data;
					}
				});
			},
			getSalesPageData() {
				api.getSalesPageData().then(res => {
					if (res.code === 0) {
						this.mainCateList = res.data.mainCateList.records;
						this.mainCateList.forEach(e => {
							if (e.mainCategoryFile) {
								e.mainCategoryFile = JSON.parse(e.mainCategoryFile);
								e.mainCategoryFile = api.fileServer + e.mainCategoryFile.url;
							}
						});
						this.subCateList = res.data.subCateList.records;
						this.subCateList.forEach(e => {
							if (e.subCategoryFile) {
								e.subCategoryFile = JSON.parse(e.subCategoryFile);
								e.subCategoryFile = api.fileServer + e.subCategoryFile.url;
							}
						});
					}
				});
			},
			getCartList() {
				let data = {
					memberDeliveryAddressUuid: this.getAddressUuid()
				};
				api.webGetShoppingCartList(data).then(res => {
					if (res.code === 0) {
						this.cartList = res.data.cartItems;
						this.updatePreSaleOrderQuantityByCart();
					}
				});
			},
			updatePreSaleOrderQuantityByCart() {
				if (this.cartList.length > 0 && this.prodcutItems.length > 0) {
					this.prodcutItems.forEach(p => {
						let tempCart = this.cartList.find(c => {
							return c.storeOrPlanUuid === p.preSalePlanUuid;
						});
						if (tempCart) {
							p.orderQuantity = tempCart.orderQuantity;
						}
					});
				}
			},
			getShowingImage(p) {
				let showingImage = null;
				let imageUrl = '';
				switch (p.productFontImageIndex) {
					case 1:
						showingImage = p.productFinishImageFile;
						break;
					case 2:
						showingImage = p.productSeedImageFile;
						break;
					case 3:
						showingImage = p.productTraySeedImageFile;
						break;
					case 4:
						showingImage = p.productPackImageFile;
						break;
				}
				if (showingImage) {
					let tempImage = JSON.parse(showingImage);
					imageUrl = api.fileServer + tempImage.url;
				}

				return imageUrl;
			},
			getProductList() {
				this.feSearch.existOnly = this.existOnly;
				this.showSpin = true;

				this.feSearch.order.enable = false;
				this.feSearch.order.conditions = [];
                
				let endYear=Math.max(...this.yearList);
				api.getProductList({...this.feSearch,endYear}).then(res => {
					this.showSpin = false;
					if (res.code === 0) {
						this.prodcutItems = res.data.records;
						this.prodcutItems.forEach(p => {
							p.productPreSaleWarehouseAmount=p.productMinOrderAmount;
							p.showImageUrl = this.getShowingImage(p);
						});
						search.globalSetFilterRecordCount(this.feSearch, res.data.filterRecordCount);
					}
				});
				this.setDeliveryDays();
			},
			// 字符串格式：2020-10-13转日期Date
			stringToDate(strDate) {
				var dateStrs = strDate.split("-");
				var year = parseInt(dateStrs[0], 10);
				var month = parseInt(dateStrs[1], 10) - 1;
				var day = parseInt(dateStrs[2], 10);

				var hour = 0;
				var minute = 0;
				var second = 0;

				var date = new Date(year, month, day, hour, minute, second);
				return date;
			},
			getDateString(now) {
				let year = now.getFullYear();
				let month = now.getMonth() + 1;
				if (month < 10) {
					month = "0" + month;
				}
				let day = now.getDate();
				if (day < 10) {
					day = "0" + day;
				}
				return `${year}-${month}-${day}`;
			},
			getPreSaleProductList(productUuid) {
				let tempSearch = search.getSearchParams();
				tempSearch.years = this.selectedYear;
				let weekKnownTexts = this.weekList.map(e => {
					return e.weekKnownText;
				});
				tempSearch.weekKnownTexts = weekKnownTexts;
				tempSearch.distributionStationUuid = '';
				tempSearch.distUuid = '';

				tempSearch.filters.enable = true;
				tempSearch.filters.conditions.push({
					name: 'productUuid',
					type: 'eq',
					value: productUuid
				});
				this.filterModel.selectedYearPlans = [];
				//获取预售计划信息
				this.showSpin = true;
				api.webGetPreSaleProductList(tempSearch).then(res => {
					this.showSpin = false;
					if (res.code === 0) {
						if (res.data.records.length > 0) {
							this.filterModel.selectedYearPlans = Object.values(res.data.records[0].plans);
							//只显示有库存的
							this.filterModel.selectedYearPlans = this.filterModel.selectedYearPlans.filter((e,
								index) => {
								return e.preSalePlanOfferAmount > 0;
							});
							let newWeekList=[];
							this.weekList.forEach(e => {
								this.filterModel.selectedYearPlans.forEach(item => {
									if(item.weekKnownText==e.weekKnownText){
										newWeekList.push(e);
									}
								});
							});
							if(newWeekList.length>0){
								this.filterModel.newWeekList=newWeekList;
								//this.filterModel.dayList=[];
								this.filterModel.selectedWeek = newWeekList[0].weekKnownText;
								// let nowString = this.getDateString(new Date());
								// let weekBeginDate=newWeekList[0].weekBeginDate;
								// let weekEndDate=newWeekList[0].weekEndDate;
								this.setDeliveryDays();
								// if(weekBeginDate>=nowString){
								// 	this.filterModel.dayList.push(weekBeginDate);
								// }

								// let weekBeginDateTime=this.stringToDate(weekBeginDate);

								// let secondDateTime=new Date(weekBeginDateTime.setDate(weekBeginDateTime.getDate()+1));
								// let secondString = this.getDateString(secondDateTime);
								// if(secondString>=nowString){
								// 	this.filterModel.dayList.push(this.getDateString(secondDateTime));
								// }

								// let thirdDateTime=new Date(weekBeginDateTime.setDate(weekBeginDateTime.getDate()+1));
								// let thirdString = this.getDateString(thirdDateTime);
								// if(thirdString>=nowString){
								// 	this.filterModel.dayList.push(this.getDateString(thirdDateTime));
								// }

								// let fourthDateTime=new Date(weekBeginDateTime.setDate(weekBeginDateTime.getDate()+1));
								// let fourthString = this.getDateString(fourthDateTime);
								// if(fourthString>=nowString){
								// 	this.filterModel.dayList.push(this.getDateString(fourthDateTime));
								// }

								// let fifthDateTime=new Date(weekBeginDateTime.setDate(weekBeginDateTime.getDate()+1));
								// let fifthString = this.getDateString(fifthDateTime);
								// if(fifthString>=nowString){
								// 	this.filterModel.dayList.push(this.getDateString(fifthDateTime));
								// }

								// let sixthDateTime=new Date(weekBeginDateTime.setDate(weekBeginDateTime.getDate()+1));
								// let sixthString = this.getDateString(sixthDateTime);
								// if(sixthString>=nowString){
								// 	this.filterModel.dayList.push(this.getDateString(sixthDateTime));
								// }

								// let seventhDateTime=new Date(weekBeginDateTime.setDate(weekBeginDateTime.getDate()+1));
								// let seventhString = this.getDateString(seventhDateTime);
								// if(seventhString>=nowString){
								// 	this.filterModel.dayList.push(this.getDateString(seventhDateTime));
								// }

								//this.filterModel.selectDay=this.filterModel.dayList[0];
								this.filterModel.selectedYearPlans.forEach((plan) => {
										if(plan.weekKnownText == this.filterModel.selectedWeek){
											//实时更新价格
											this.updatePrice(plan.preSalePlanProductUuid, plan.preSalePlanPrice);
											return;
										}
									});
							}
							else{
								this.$bvModal.msgBoxOk("选择的商品当前年度内没有销售计划，请选择其它商品！", {
									title: '提示',
									buttonSize: 'sm'
								});
								this.filterModel.newWeekList=[];
								this.weekList=[];
								this.filterModel.dayList=[];
								this.filterModel.selectedWeek ='';
								//this.filterModel.selectDay='';
							}
							//当前可选择的销售计划有这些月份
							/* this.tipText="当前可选择的周次有："+selectWeeks; */
						}
						else{
							this.$bvModal.msgBoxOk("选择的商品当前年度内没有销售计划，请选择其它商品！", {
								title: '提示',
								buttonSize: 'sm'
							});
							this.filterModel.newWeekList=[];
							this.weekList=[];
							this.filterModel.dayList=[];
							this.filterModel.selectedWeek ='';
							//this.filterModel.selectDay='';
							//当前没有销售计划
							/* this.tipText="当前没有销售计划,所有日期都选择不了"; */
						}
					}
					else{
						this.$bvModal.msgBoxOk("选择的商品当前年度内没有销售计划，请选择其它商品！", {
							title: '提示',
							buttonSize: 'sm'
						});
						this.filterModel.newWeekList=[];
						this.weekList=[];
						this.filterModel.dayList=[];
						this.filterModel.selectedWeek ='';
						//this.filterModel.selectDay='';
						//获取销售计划信息异常，请退出登录重新再尝试
						/* this.tipText="获取销售计划信息异常，请退出登录重新再尝试"; */
					}
				});
			},
			changeDays(item){
				if (this.filterModel.selectedWeek) {
					let week = this.filterModel.newWeekList.find(e => {
						return e.weekKnownText === this.filterModel.selectedWeek;
					});

                    this.filterModel.selectedYearPlans.forEach((plan) => {
                    	if(plan.weekKnownText == this.filterModel.selectedWeek){
                            //实时更新价格
                            this.updatePrice(plan.preSalePlanProductUuid, plan.preSalePlanPrice);
                    		return;
                    	}
                    });

					if(week){
						let nowString = this.getDateString(new Date());
						this.filterModel.dayList=[];
						let weekBeginDate=week.weekBeginDate;
						let weekEndDate=week.weekEndDate;
						this.setDeliveryDays();
						// if(weekBeginDate>=nowString){
						// 	this.filterModel.dayList.push(weekBeginDate);
						// }

						// let weekBeginDateTime=this.stringToDate(weekBeginDate);
						// let secondDateTime=new Date(weekBeginDateTime.setDate(weekBeginDateTime.getDate()+1));
						// let secondString = this.getDateString(secondDateTime);
						// if(secondString>=nowString){
						// 	this.filterModel.dayList.push(this.getDateString(secondDateTime));
						// }

						// let thirdDateTime=new Date(weekBeginDateTime.setDate(weekBeginDateTime.getDate()+1));
						// let thirdString = this.getDateString(thirdDateTime);
						// if(thirdString>=nowString){
						// 	this.filterModel.dayList.push(this.getDateString(thirdDateTime));
						// }

						// let fourthDateTime=new Date(weekBeginDateTime.setDate(weekBeginDateTime.getDate()+1));
						// let fourthString = this.getDateString(fourthDateTime);
						// if(fourthString>=nowString){
						// 	this.filterModel.dayList.push(this.getDateString(fourthDateTime));
						// }

						// let fifthDateTime=new Date(weekBeginDateTime.setDate(weekBeginDateTime.getDate()+1));
						// let fifthString = this.getDateString(fifthDateTime);
						// if(fifthString>=nowString){
						// 	this.filterModel.dayList.push(this.getDateString(fifthDateTime));
						// }

						// let sixthDateTime=new Date(weekBeginDateTime.setDate(weekBeginDateTime.getDate()+1));
						// let sixthString = this.getDateString(sixthDateTime);
						// if(sixthString>=nowString){
						// 	this.filterModel.dayList.push(this.getDateString(sixthDateTime));
						// }

						// let seventhDateTime=new Date(weekBeginDateTime.setDate(weekBeginDateTime.getDate()+1));
						// let seventhString = this.getDateString(seventhDateTime);
						// if(seventhString>=nowString){
						// 	this.filterModel.dayList.push(this.getDateString(seventhDateTime));
						// }

						//this.filterModel.selectDay=weekBeginDate;
					}
				}
			},
			onWeekSelectChange(product) {
				if(this.hadSelectedProductUuids.length==0){
					this.hadSelectedProductUuids.push(product.productUuid);
					this.getPreSaleProductList(product.productUuid);
				}
				else{
					if(this.hadSelectedProductUuids.indexOf(product.productUuid)==-1){
						this.hadSelectedProductUuids.push(product.productUuid);
						this.getPreSaleProductList(product.productUuid);
					}
				}
			},
			// 按产品编码或名称搜索
			searchProductByName() {
				let field = "CONCAT(productName, productCode)";
				search.globalRemoveFilterConditionKey(this.feSearch, field);
				this.feSearch.filters.enable = true;
				this.feSearch.filters.conditions.push({
					name: field,
					type: 'like',
					value: this.productSearchValue
				});
				search.globalResetSearch(this.feSearch);
				this.getProductList();
			},

			// 搜索产品颜色
			onProductColorChange(productColor) {
				search.globalRemoveFilterConditionKey(this.feSearch, 'productColor');
				this.feSearch.filters.enable = true;
				if (productColor !== '') {
					this.feSearch.filters.conditions.push({
						name: 'productColor',
						type: 'like',
						value: productColor
					});
				}
				search.globalResetSearch(this.feSearch);
				this.getProductList();
			},
			//加入购物车
			addToCart(product) {
				if (!this.checkMemberLogin()) {
					this.$bvModal.msgBoxOk("请先登录", {
						title: '提示',
						buttonSize: 'sm'
					});
					return;
				}
				//指定单位的产品可以输入小数，不用判断
				if (!this.getUnitIsRounded(product.unitName)) {
					if (product.productPreSaleWarehouseAmount % product.productIncreaseStepAmount !== 0) {
						this.$bvModal.msgBoxOk("订购数量必须是最小订购单位的整数倍", {
							title: '提示',
							buttonSize: 'sm'
						});
						return;
					}
					if (product.productPreSaleWarehouseAmount < product.productMinOrderAmount) {
						this.$bvModal.msgBoxOk("非常抱歉，订购数量不能小于最低起订量！", {
							title: '提示',
							buttonSize: 'sm'
						});
						return;
					}
				}
				else{
					 if (product.productPreSaleWarehouseAmount <=0) {
						this.$bvModal.msgBoxOk("非常抱歉，订购数量不能为0！", {
							title: '提示',
							buttonSize: 'sm'
						});
						return;
					}
				}

				if(this.filterModel.selectedWeek==''){
					this.$bvModal.msgBoxOk("非常抱歉，周次不能为空！", {
						title: '提示',
						buttonSize: 'sm'
					});
					return;
				}
				if(product.selectDay==''){
					this.$bvModal.msgBoxOk("非常抱歉，发货日期不能为空！", {
						title: '提示',
						buttonSize: 'sm'
					});
					return;
				}

				let tempSearch = search.getSearchParams();
				tempSearch.years = this.selectedYear;
				let weekKnownTexts = this.weekList.map(e => {
					return e.weekKnownText;
				});
				tempSearch.weekKnownTexts = weekKnownTexts;
				tempSearch.distributionStationUuid = '';
				tempSearch.distUuid = '';

				tempSearch.filters.enable = true;
				tempSearch.filters.conditions.push({
					name: 'productUuid',
					type: 'eq',
					value: product.productUuid
				});
				this.filterModel.selectedYearPlans = [];
				//获取选中产品的预售计划信息
				this.showSpin = true;
				api.webGetPreSaleProductList(tempSearch).then(res => {
					this.showSpin = false;
					if (res.code === 0) {
						if (res.data.records.length > 0) {
							this.filterModel.selectedYearPlans = Object.values(res.data.records[0].plans);
							//只显示有库存的
							this.filterModel.selectedYearPlans = this.filterModel.selectedYearPlans.filter((e,
								index) => {
								return e.preSalePlanOfferAmount > 0;
							});
							let submitSource = 'PC';
							let preSalePlanUuid="";
							this.filterModel.selectedYearPlans.forEach((item) => {
								if(item.weekKnownText==this.filterModel.selectedWeek){
                                    //实时更新价格
                                    this.updatePrice(item.preSalePlanProductUuid, item.preSalePlanPrice);
									preSalePlanUuid=item.preSalePlanUuid;
									return;
								}
							});
							if(preSalePlanUuid==""){
								this.$Modal.error({ title: '出错啦', content: '非常抱歉，选择日期中该产品没有销售计划，请重新选择日期！' });
								return;
							}
							this.showSpin = true;
							api.webSubmitToOrder({
								loginUuid:this.getLoginCookieUuid(),
								planUuid: preSalePlanUuid,
								orderQuantity: product.productPreSaleWarehouseAmount,
								submitSource: submitSource,
								sendProductDate:product.selectDay,
								distributionStationUuid: '',
								distUuid: ''
							}).then(res => {
								this.showSpin = false;
								if (res.code === 0) {
									this.$bvModal.msgBoxOk("成功添加到购物车，可以继续选购！", {
										title: '提示',
										buttonSize: 'sm'
									});
									this.getPreSalePlanProduct();
								}
							});

						}
						else{
							this.$bvModal.msgBoxOk("选择的商品当前年度内没有销售计划，请选择其它商品！", {
								title: '提示',
								buttonSize: 'sm'
							});
							this.filterModel.newWeekList=[];
							this.weekList=[];
							this.filterModel.dayList=[];
							this.filterModel.selectedWeek ='';
							//this.filterModel.selectDay='';
							//当前没有销售计划
							/* this.tipText="当前没有销售计划,所有日期都选择不了"; */
						}
					}
					else{
						this.$bvModal.msgBoxOk("选择的商品当前年度内没有销售计划，请选择其它商品！", {
							title: '提示',
							buttonSize: 'sm'
						});
						this.filterModel.newWeekList=[];
						this.weekList=[];
						this.filterModel.dayList=[];
						this.filterModel.selectedWeek ='';
						//this.filterModel.selectDay='';
						//获取销售计划信息异常，请退出登录重新再尝试
						/* this.tipText="获取销售计划信息异常，请退出登录重新再尝试"; */
					}
				});
			},
			onPageChange(pageNum) {
				search.globalRemoveFilterConditionKey(this.feSearch, 'productUuid');
				search.globalPageOnChange(this.feSearch, pageNum);
				this.getProductList();
			},
			 getUnitList() {
			   api.getUnitList().then(res => {
					if (res.code == 0) {
						this.unitList = res.data.records
					}
				})
			},
			getUnitIsRounded(unitName) {
				let unitPro = this.unitList.find(x => x.unitName == unitName);
				if (!unitPro) {
					return false;
				}
				return unitPro.isRounded == 0 ;
			},

			// 清理 SignalR 事件监听器
			cleanupSignalRListeners() {
				if (signalr && signalr.off) {
					signalr.off('PreSalePlanUpdated');
					signalr.off('ProductPriceUpdated');
					signalr.off('reconnecting');
					signalr.off('reconnected');
					console.log('SignalR 事件监听器已清理');
				}
			},
        setDeliveryDays() {
			if (this.filterModel.selectedWeek) {
					let week = this.filterModel.newWeekList.find(e => {
						return e.weekKnownText === this.filterModel.selectedWeek;
					});
					this.prodcutItems.forEach(item => {
						item.dayList = [];
						let startDate = new Date(week.weekBeginDate);
						let endDate = new Date(week.weekEndDate);
						const curDate= this.getDateString(new Date());
						//默认添加开始日期
						item.selectDay=curDate;
						for (let d = startDate; d <= endDate; ) {
							const dayOfWeek = d.getDay();
							const dayString = this.getDateString(d);
							if (dayString>=curDate) {
								item.dayList.push(dayString);
								if (dayOfWeek===item.seedFarmDeliveryWeek) {
									item.selectDay=dayString;
								}
							}
							d = new Date(d.setDate(d.getDate() + 1));
						}
				});
				}
        }
		},
		filters: {
			formatAvailableBalance(memberInfo){
			  let memberFund=!memberInfo.memberFund?0:memberInfo.memberFund;
			  let depositBablance= !memberInfo.depositBablance?0:memberInfo.depositBablance;
			  let availableFund=numberSubtraction(memberFund,depositBablance);
			  let result= getNumberThousandString(getNumberFloorDecimal(availableFund,2),'0.00')
			   return	result;
			}
		},
		beforeDestroy() {
			// 组件销毁时清理 SignalR 事件监听器
			this.cleanupSignalRListeners();
		}
	};
</script>

<style scope>
	.list-group-item.active {
		background-color: #00b151 !important;
		border-color: #00b151 !important;

	}

	.list-group-item {
		box-shadow: 5px 3px 5px #f0f0f0;
	}

	.table-cloumn-max-width {
		max-width: 100px;
	}

	.table-field-align-left {
		text-align: left !important;
	}

	.selectcatefont {
		color: red !important;
	}

	.sidebar-subcate {
		margin-left: 20px;
		margin-bottom: 6px;
		margin-top: 6px;
		font-size: 14px;
		word-break: keep-all;
		display: inline-block;
		text-decoration: none !important;
		color: grey;
	}

	.orderButton {
		margin-top: 20px;
		text-align: right;
	}

	.table-bordered td,
	.table-bordered th {
		vertical-align: middle;
	}

	.col-lg-2,
	.col-lg-3,
	.col-lg-7 {
		padding-right: 0;
	}

	.selectcateborder {
		border: solid 2px red !important;
	}

	.card-img,
	.card-img-top {
		height: 62px;
	}

	.modal-body {
		overflow: auto !important;
	}

	/*产品_tag修改选择月份样式*/
	.nav-tabs {
		background-color: #fafafa;
		border-bottom: none;
		padding: 5px;
		margin-bottom: 10px;
	}

	.nav-tabs .nav-link.active {
		color: #00b151;
		border-bottom: 2px solid #00b151;
		background-color: transparent;
		font-weight: 600;
	}

	.nav-link {
		color: #000000;
	}

	.nav-link:hover {
		color: #00b151;
	}

	.nav-tabs .nav-link {
		border: none;
	}

	/*产品_修改侧栏产品选项样式*/
	.product-list {
		height: 60px;
		line-height: 50px;
	}

	.product-list:hover {
		background-color: #f7f9fa;
	}

	/*产品_修改侧栏会员充值样式*/
	.product-pay {
		margin-top: 10px;
		border: 1px solid #f3f3f3;
		background-color: #f9f9f9;
		width: 100%;
		
		border-radius: 5px;
		text-align: center;
		padding-top: 5px;
		line-height: 25px;
	}
	
	.product-pay-height1{
		height: 150px;
	}
	.product-pay-height2{
		height: 100px;
	}

	/*产品_修改产品主表样式*/
	.dataTable th {
		background-color: #fff;
		white-space: nowrap;
		line-height: 40px;
		text-align: center;
	}

	.table thead th {
		border-bottom: 1px;
	}

	.table td a {
		color: #00b151;
	}

	/*产品_主表表格行交替背景色样式*/
	.dataTable tr:nth-child(odd) {
		background: #fafafa;
	}

	.dataTable tr:nth-child(even) {
		background: #ffffff;
	}

	/*产品_修改页脚翻页样式*/
	.page-link {
		color: #757575 !important;
	}

	.page-link:hover {
		color: #00b151 !important;
	}

	.page-item.active .page-link {
		color: #fff !important;
		background-color: #28a745 !important;
		border-color: #28a745 !important;
	}

	.pagination-sm .page-link {
		padding: 5px 12px !important;
		margin-top: 40px;
	}

	.page-link:focus {
		box-shadow: none !important;
	}


	/* .custom-control-label:after, .custom-control-label:before{position: absolute;
	top: 8px;
    left: -20px;
    display: block;
    width: 1rem;
    height: 1rem;
    content: "";} */
	.custom-control-label {
		padding-top: 0px !important;
	}

	.custom-control-input:checked~.custom-control-label::before {
		color: #fff !important;
		border-color: #00b151 !important;
		background-color: #00b151 !important;
	}

	.custom-checkbox .custom-control-input:checked~.custom-control-label::after {
		background-color: #01B252 !important;
	}

	.input-group-append .btn-secondary.focus,
	.input-group-append .btn-secondary:focus,
	.input-group-append .btn-secondary:hover {
		border-color: none !important;
	}

	.search-productInfo .btn-secondary{color: #fff;background-color: #00b151 !important;border-color: #00b151 !important;}
	.search-color label{margin-right:5px;background-color:#F7F7F7;margin-bottom:0px !important;height:30px;line-height:30px;}
	.table-cloumn-min-width{min-width: 130px;}
</style>



// WEBPACK FOOTER //
// src/view/product/product-list.vue